import { orderSlice } from '../../../Slice/Order/OrderSlice.js'
import type { Epic } from 'Flux/index.js'
import { filter, map, mergeMap, of } from 'rxjs'
import { catchError } from 'rxjs/operators'
import { isNegativeControl, isSample } from '../../../../Model/index.js'
import { withBlockingRequest } from '../../Application/withBlockingRequest.js'

export const ConvertPoolItemEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.convertPoolItemRequest.match),
    mergeMap(({ payload }) => {
      const { orderId, poolId, item } = payload

      const targetItemType = isSample(item) ? 'NEGATIVE_CONTROL' : 'SAMPLE'

      // Conversion is reversible: we no longer delete the sample's metadata when converting to NC.
      // The backend keeps the (now shadowed) metadata row and simply ignores it for NC items, so
      // converting back to SAMPLE restores it. We only flip the item type here.
      const convert$ = OrderRepository.updatePoolContent(orderId, poolId, [{
        ...item,
        itemType: targetItemType
      }])

      return withBlockingRequest(
        convert$.pipe(
          map((items) => {
            const first = items[0]
            if (!first) {
              return order.convertPoolItemRequestFailure({ error: Error('Could not convert pool item') })
            }
            if (targetItemType === 'NEGATIVE_CONTROL' && !isNegativeControl(first)) {
              return order.convertPoolItemRequestFailure({ error: Error('Could not convert to negative control') })
            }
            if (targetItemType === 'SAMPLE' && isNegativeControl(first)) {
              return order.convertPoolItemRequestFailure({ error: Error('Could not convert to sample') })
            }
            return order.convertPoolItemRequestSuccess({ orderId, poolId, item: first })
          }),
          catchError((error) => of(order.convertPoolItemRequestFailure({ error })))
        ),
        'Converting Pool Item',
        'Please wait'
      )
    })
  )
